import XlsxTemplate from 'xlsx-template';
import excelFieldFormatter, { dateTimeWithSeconds } from '../ExcelFieldFormatter';

export const fieldFormatterMapper = {
  date: (value) => excelFieldFormatter('date')({ value }, 'DD/MMM/YYYY'),
  dateTime: (value) => excelFieldFormatter('dateTime')({ value }, 'DD/MMM/YYYY HH:mm'),
  dateWithDay: (value) => excelFieldFormatter('dateWithDay')({ value }, 'ddd DD/MMM/YYYY'),
  number: (value) => excelFieldFormatter('number')({ value }),
  float: (value) => excelFieldFormatter('float')({ value }),
  boolean: (value) => excelFieldFormatter('boolean')({ value }),
  commaText: (value) => excelFieldFormatter('commaText')({ value }),
  dateTimeWithSeconds: (value) => excelFieldFormatter('dateTimeWithSeconds')({ value }, 'DD/MMM/YYYY HH:mm:ss'),
};

function findColumn(columns, accessorName) {
  return columns.filter((column) => column.accessor === accessorName && column.Cell.name !== '');
}

function formatColumn(column, value) {
  if (column != null && column.length !== 0) {
    const formatFunction = fieldFormatterMapper[column[0].Cell.name];
    return formatFunction ? formatFunction(value) : value;
  }
  return value;
}

function formatRow(row, columns) {
  const newRow = {};
  Object.keys(row).forEach((field) => {
    const column = findColumn(columns, field);
    newRow[field] = formatColumn(column, row[field]);
  });
  return {
    ...newRow,
  };
}

function formatData(data, columns) {
  return data.map((row) => formatRow(row, columns));
}

function mapReactTableDataToExcelData(data, columns) {
  return {
    rows: formatData(data, columns),
  };
}

export default function populateExcelFile(templateFile, data, columns) {
  const tableData = mapReactTableDataToExcelData(data, columns);
  const template = new XlsxTemplate(templateFile);
  template.substitute('Sheet1', tableData);

  return template.generate();
}
